import { createClient } from "@/createClient";
import { PlatformApiFactory } from "@eloomi/eloomi-platforms-external-client/1.0";

const platformClient = createClient(PlatformApiFactory);

export default async (domain, _platformName): Promise<boolean> => {
    const result = await platformClient.resolveDomain(domain);
    return result.status === 204;
}
